import React from 'react';
import { Link } from 'react-router-dom';
import { FiChevronRight } from 'react-icons/fi';

/**
 * Standard page header: optional breadcrumb, title + subtitle, end-aligned
 * actions that wrap below on small screens.
 * breadcrumb: [{ label, to }] — last item rendered as plain text.
 */
export default function PageHeader({ title, subtitle, breadcrumb, actions, className = '' }) {
  return (
    <div className={`mb-6 ${className}`}>
      {breadcrumb && breadcrumb.length > 0 && (
        <nav className="flex items-center gap-1.5 text-sm text-content-muted mb-2 overflow-x-auto scrollbar-hide">
          {breadcrumb.map((item, i) => {
            const isLast = i === breadcrumb.length - 1;
            return (
              <React.Fragment key={i}>
                {i > 0 && <FiChevronRight size={14} className="shrink-0 rtl:-scale-x-100" />}
                {isLast || !item.to ? (
                  <span className={`whitespace-nowrap ${isLast ? 'text-content-secondary font-medium' : ''}`}>
                    {item.label}
                  </span>
                ) : (
                  <Link to={item.to} className="whitespace-nowrap hover:text-accent transition-colors">
                    {item.label}
                  </Link>
                )}
              </React.Fragment>
            );
          })}
        </nav>
      )}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <div className="min-w-0">
          <h1 className="text-xl sm:text-2xl font-bold text-content truncate">{title}</h1>
          {subtitle && <p className="mt-0.5 text-sm text-content-secondary">{subtitle}</p>}
        </div>
        {actions && <div className="flex flex-wrap items-center gap-2 sm:gap-3 shrink-0">{actions}</div>}
      </div>
    </div>
  );
}
